import { consoleLogError } from "../console";

export const getWordsCount = (str) => {
  if (!str) {
    return 0;
  }

  const match = str.match(/(\w+)/g);
  return match ? match.length : 0;
};

export const getWordsFromString = (str) => {
  if (!str) {
    return null;
  }

  return str.match(/\b(\w+)\b/g);
};

export const getShorterString = (str1, str2) => {
  if (str1 && str2) {
    return str1.length > str2.length ? str2 : str1;
  }

  return str1 || str2;
};

export const addQuotes = (str) => "\"" + str + "\"";
export const addParentheses = (str) => "(" + str + ")";

export const escapeRegExp = (str) => str.toString().replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export const threeDotsIfLongerThan = (lengthMax, str) => {
  if (typeof str === "string") {
    if (str.length > lengthMax) {
      return str.slice(0, lengthMax - 1) + "…";
    }
    return str;
  }
  return "";
};

const isLetterSeparatorSign = (letter) => {
  if (typeof letter === "string") {
    return letter.match(/[,;\-–“"']/);
  }

  consoleLogError("isLetterSeparatorSign", "Invalid argument: ", {letter});

  return "";
};
const isLetterInvalidAsSentenceBegin = (letter) => {
  if (typeof letter === "string") {
    // consider any digit letter as no valid, because it's impossible
    // to determine whether this number is full.
    return letter.match(/[0-9]/) || letter !== letter.toUpperCase();
  }

  consoleLogError("isLetterInvalidAsSentenceBegin", "Invalid argument: ", {letter});

  return "";
};
const isLetterInvalidAsSentenceEnd = (letter) => {
  if (typeof letter === "string") {
    // consider any digit letter as no valid, because it's impossible
    // to determine whether this number is full.
    return letter.match(/[0-9]/) || !letter.match(/[.!?]/);
  }

  consoleLogError("isLetterInvalidAsSentenceEnd", "Invalid argument: ", {letter});

  return "";
};

// Check a test file for better understanding.
export const formatTextExcerpt = (str) => {
  if (typeof str === "string") {
    let out = str.trim();

    if (out) {
      if (isLetterInvalidAsSentenceBegin(out[0])) {
        const indexLetterSpace = out.indexOf(" ");
        if (indexLetterSpace !== -1 && indexLetterSpace !== out.length - 1) {
          out = out.slice(indexLetterSpace + 1);
        }
      }
      if (out.length > 1 && isLetterSeparatorSign(out[0])) {
        out = out.slice(1);
      }

      if (isLetterInvalidAsSentenceEnd(out[out.length - 1])) {
        const lastIndexLetterSpace = out.lastIndexOf(" ");
        if (lastIndexLetterSpace !== -1 && lastIndexLetterSpace > 1) {
          out = out.slice(0, lastIndexLetterSpace);
        }
      }
      if (out.length > 1 && isLetterSeparatorSign(out[out.length - 1])) {
        out = out.slice(0, out.length - 1);
      }

      out = out.trim();

      if (isLetterInvalidAsSentenceBegin(out[0])) {
        out = "…" + out;
      }
      if (isLetterInvalidAsSentenceEnd(out[out.length - 1])) {
        out = out + "…";
      }
    }

    return out;
  }

  consoleLogError("formatTextExcerpt", "Invalid string argument: ", {str});

  return "";
};

export const clearSignsInString = (str) => {
  if (typeof str === "string") {
    return str.replace(/["\-–,;.!?*]/g, "");
  }

  consoleLogError("clearSignsInString", "Invalid string argument: ", {str});

  return "";
};

export const capitalize = (str, eachWord) => {
  if (!str || typeof str !== "string") {
    return "";
  }

  if (eachWord) {
    return str.split(" ").map(capitalize).join(" ");
  }

  return str[0].toUpperCase() + str.slice(1);
};
